<template>
  <div>
    123123
  </div>
</template>

<script>
  export default {
    name: "razorPay"
  }
</script>

<style scoped>

</style>